<template>
  <div class="app-container text-center">
    <div>
      <div :class="className" :id="chart_id" :style="{height:height, width: device === 'desktop' ? '50%' : '100%', margin:margin}" />
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>净值估算</div>
            <h2 :style="{ color: valueColor }">{{ saleFundInfoChart.value }}
              <i :class="valueColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
            </h2>
            <div>近期：{{ saleFundInfoChart.recent_value }}</div>
          </v-flex>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>单位净值</div>
            <h2 :style="{ color: unitColor }">{{ saleFundInfoChart.unit_value }}
              <i :class="unitColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
            </h2>
            <div>近期：{{ saleFundInfoChart.recent_unit_value }}</div>
          </v-flex>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>累计净值</div>
            <h2 :style="{ color: cumulativeColor }">{{ saleFundInfoChart.cumulative_value }}
              <i :class="cumulativeColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
            </h2>
            <div>近期：{{ saleFundInfoChart.recent_cumulative_value }}</div>
          </v-flex>
        </v-layout>
        <hr>
        <v-layout row wrap>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>基金类型：{{ saleFundInfoChart.type }}</div>
            <div>成立日：{{ saleFundInfoChart.estabilsh_date }}</div>
          </v-flex>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>基金规模：{{ saleFundInfoChart.scale }}</div>

            <div>
              管理人：
              <router-link :to="`/saleCompany/${company_id}`">
                {{ companyName }}
              </router-link>
            </div>
          </v-flex>
          <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
            <div>
              基金经理：
              <router-link :to="'/saleMemberInfo/' + sale_member_id">
                {{ name }}
              </router-link>
            </div>
            <!-- <div>
              <v-rating v-model="saleFundInfoChart.rating" background-color="orange lighten-3" color="orange" small readonly></v-rating>
            </div> -->
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import echarts from 'echarts'

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    chart_id: {
      type: String,
      default: 'pos_chart'
    },
    width: {
      type: String,
      default: '800px'
    },
    height: {
      type: String,
      default: '600px'
    },
    margin: {
      type: String,
      default: '0 auto'
    }
  },
  data() {
    return {
      route_id: this.$route.params && this.$route.params.id,
      chart: null,
      items: {},
      device: 'desktop',
      sale_member_id: '',
      name: '',
      company_id: '',
      companyName: '',
      valueColor: '',
      unitColor: '',
      cumulativeColor: ''
    }
  },
  computed: mapGetters({
    saleFundInfoChart: 'saleFundInfoChart',
    saleMemberInfo: 'saleMemberInfo'
  }),
  watch: {
    saleFundInfoChart: {
      handler(newValue, oldValue) {
        if (this.chart) {
          if (newValue) {
            this.chart.clear()
            this.initChart(newValue)
          } else {
            this.initChart(oldValue)
          }
        } else {
          this.init()
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    fetchData() {
      this.listLoading = true
      this.$store
        .dispatch('GetSaleFundInfoChart', this.route_id)
        .then(response => {
          this.valueColor =
            this.saleFundInfoChart.value - this.saleFundInfoChart.recent_value <
            0
              ? 'green'
              : 'red'
          this.unitColor =
            this.saleFundInfoChart.unit_value -
              this.saleFundInfoChart.recent_unit_value <
            0
              ? 'green'
              : 'red'
          this.cumulativeColor =
            this.saleFundInfoChart.cumulative_value -
              this.saleFundInfoChart.recent_cumulative_value <
            0
              ? 'green'
              : 'red'

          this.$store
            .dispatch(
              'GetSaleMemberInfo',
              this.saleFundInfoChart.sale_member_id
            )
            .then(res => {
              this.sale_member_id = this.saleMemberInfo[0].id
              this.name = this.saleMemberInfo[0].name
              this.company_id = this.saleMemberInfo[0].company_id
              this.companyName = this.saleMemberInfo[0].company_title
            })
          this.listLoading = false
        })
    },
    initChart(items) {
      this.chart = echarts.init(document.getElementById(this.chart_id))

      const valueData = [
        this.saleFundInfoChart.value,
        this.saleFundInfoChart.unit_value,
        this.saleFundInfoChart.cumulative_value
      ]
      const currentValueData = [
        this.saleFundInfoChart.recent_value,
        this.saleFundInfoChart.recent_unit_value,
        this.saleFundInfoChart.recent_cumulative_value
      ]

      const option = {
        title: {
          text: '净值图表'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'bar'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: ['净值估算', '单位净值', '累计净值']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '净值',
            type: 'bar',
            data: valueData,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }]
            }
          },
          {
            name: '最近净值',
            type: 'bar',
            data: currentValueData,
            markPoint: {
              data: [{ name: '最大值' }, { name: '最小值' }]
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }]
            }
          }
        ]
      }
      option.series[0].data = valueData
      option.series[1].data = currentValueData
      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-rate::before {
  content: '基金評級：';
}
</style>

